module.exports = __webpack_public_path__ + "static/media/TDSLOGO.1b1a68ee.png";